import { apiService } from '@clarix/api-client';
import type {
  DirectoryListResponse,
  DirectoryMember,
  ManagerEdge,
} from '@clarix/shared-types';

/**
 * Member-readable reads of the workspace members directory (keyed on membership
 * uuid, not user id). `apiService` unwraps the standard `{ success, data }` envelope.
 */
const directoryBase = (slug: string) => `/workspaces/${slug}/admin/members/directory`;

export const memberDirectoryApi = {
  /** Directory rows with a login whose name/email/employee id contains `search`. */
  searchWithAccount: (slug: string, search: string) =>
    apiService.get<DirectoryListResponse>(directoryBase(slug), {
      params: { search, has_account: true, limit: 50 },
    }),

  /** One directory row by membership id. */
  member: (slug: string, membershipId: string) =>
    apiService.get<DirectoryMember>(`${directoryBase(slug)}/${membershipId}`),

  /** A member's manager edges (primary + extras of every relationship type). */
  managerEdges: (slug: string, membershipId: string) =>
    apiService
      .get<{ managers: ManagerEdge[] }>(`${directoryBase(slug)}/${membershipId}/managers`)
      .then((r) => r.managers),
};
